import { isBrowser } from '../utils';

export function base64ToString(text: string) {
  return isBrowser ? window.atob(text) : Buffer.from(text, 'base64').toString();
}

export function stringToBase64(text: string) {
  return isBrowser ? window.btoa(text) : Buffer.from(text).toString('base64');
}

/*
import { Base64 } from 'js-base64';
import { isBrowser } from '../utils';

export function base64ToString(text: string) {
  return isBrowser ? Base64.decode(text) : Buffer.from(text, 'base64').toString();
}

export function stringToBase64(text: string) {
  return isBrowser ? Base64.encode(text) : Buffer.from(text).toString('base64');
}
*/
